import { render, staticRenderFns } from "./UserDataForm.vue?vue&type=template&id=7362ad1c&"
import script from "./UserDataForm.vue?vue&type=script&lang=js&"
export * from "./UserDataForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports